import dataProvider from '@/api'

export default {
  /**
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%9C%D0%B5%D0%BD%D1%8E/MenuGoals
   *
   * @param {object} payload
   * @param {number} payload.cityId - required
   * @param {boolean} payload.isLongation
   * @param {boolean} payload.forSubscription
   * @param {boolean} payload.family
   * @param {boolean} payload.useClientsBmi
   * @param {number} payload.menuTypeGroupId
   * @param {string} payload.firstDeliveryDate
   * @param {string} payload.session
   *
   * @returns {object}
   */
  getMenuGoals (payload) {
    return dataProvider.post('/menu/goals', payload)
  },

  /**
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%9C%D0%B5%D0%BD%D1%8E/MenuGoalsTest
   *
   * @param {object} payload
   * @param {number} payload.cityId - required
   * @param {boolean} payload.isLongation
   * @param {boolean} payload.forSubscription
   * @param {boolean} payload.clientHasSubscription
   * @param {string} payload.activityType - new, old, active, unauthorized, freshly_active, second_order_active
   *
   * @returns {object}
   */
  getMenuGoalsTest (payload = {}) {
    return dataProvider.post('/menu/goals-test', payload)
  },

  /**
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%9C%D0%B5%D0%BD%D1%8E/CustomizationInfo
   *
   * @param {object} payload
   * @param {number} payload.cityId - required
   *
   * @returns {object}
   */
  getCustomizationInfoDays (payload = {}) {
    return dataProvider.get('/customization-info/', payload)
  },

  /**
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%9C%D0%B5%D0%BD%D1%8E/CustomizationInfoMenu
   *
   * @param {object} payload
   * @param {number} payload.cityId - required
   * @param {string} payload.menuType - required
   * @param {string} payload.firstDeliveryDate - required
   * @param {number} payload.menuDays - required
   * @param {number} payload.dayTime - required
   * @param {string} payload.abonementType
   * @param {object[]} payload.filterIds
   *
   * @returns {object}
   */
  postCustomizationInfoMenu (payload = {}) {
    return dataProvider.post('/customization-info/menu', payload)
  },

  /**
   * @tutorial null
   *
   * @param {object} payload
   * @param {string} payload.menuType - required
   *
   * @returns {object}
   */
  getCustomizationInfoFilters (params = {}) {
    return dataProvider.get('/customization-info/filters/meals', params)
  },

  /**
   * @tutorial null
   *
   * @param {object} query
   * @param {string} query.menuType - required
   * @param {object} payload
   * @param {string} payload.templateIds - required
   *
   * @returns {object}
   */
  postCustomizationInfoFilters (params = {}, payload = {}) {
    return dataProvider.post('/customization-info/filters/meals', payload, { params })
  },

  /**
   * @tutorial null
   *
   * @param {object} payload
   * @param {string} payload.templateIds - required
   *
   * @returns {object}
   */
  postFiltersDays (payload = {}) {
    return dataProvider.post('/customization-info/filters/days', payload)
  },

  /**
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.17#/%D0%9C%D0%B5%D0%BD%D1%8E/MenuGoalsMain
   *
   * @param {object} payload
   * @param {number} payload.cityId - required
   * @param {boolean} payload.isLongation
   * @param {boolean} payload.forSubscription
   * @param {boolean} payload.family
   *
   * @description получение всех потребностей
   *
   * @returns {object}
   */
  getGoalsMain (payload = {}) {
    return dataProvider.post('/menu/goals/main', payload)
  },

  /**
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.17#/%D0%9C%D0%B5%D0%BD%D1%8E/MenuGoalsMain
   *
   * @param {object} payload
   * @param {number} payload.cityId - required
   * @param {boolean} payload.isLongation
   * @param {boolean} payload.forSubscription
   * @param {boolean} payload.family
   *
   * @description получение всех линеек по потребности
   *
   * @returns {object}
   */
  getGoalsCut (payload = {}) {
    return dataProvider.post('/menu/goals-cut', payload)
  },

  /**
   * @param payload
   * @description Получение доступных фильтров
   */
  getFilters (payload) {
    return dataProvider.get('/customization-info/filters', payload)
  },
  /**
   * @param payload.lastFilterIds []
   * @description Сохраняет фильтр в профиль
   * @tutorial https://swagger.growfood.pro/?urls.primaryName=Mobile%202.14#/%D0%9A%D0%BB%D0%B8%D0%B5%D0%BD%D1%82/UpdateLastFilterClientDetails
   */
  setFilters (payload) {
    return dataProvider.post('/client-details/update-last-filter', payload)
  },
  /**
   * @param payload.orderId_H order id
   * @param payload.filterIds filter ids
   * @description Установка фильтра меню для заказа
   */
  setFiltersForOrder (payload) {
    return dataProvider.post('/orders/set-filter', payload)
  },

  /**
   * @description получение расшифровки пропертей паков
   */
  getPackProperties () {
    return dataProvider.get('/libs/packs-properties')
  },

  /**
   * @param {Object} payload.cityId - айди города
   * @param {Object} payload.menuType - линейка
   * @description Получение возможных дат доставок с интервалами для меню
   */
  getPossibleDeliveryDates (payload) {
    return dataProvider.get('/customization-info/possible-dates', payload)
  },

}
